import ModalComponent from "@components/modal/Modal.component";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import AIOButtonComponent from "@components/Button.component";
import { Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import AIODropZone from "@components/AIODropZone.component";
import SelectWithSearchComponent from "@components/input/SelectWithSearch.component";
import { SelectItem } from "@components/input/Select.component";
import { jobBoardsService } from "@store/jobBoards";
import { Colors } from "@constants/colors.constant";
import { finalize } from "rxjs";
import { adDetailsService } from "@store/ads/details";
import { ApplicationsListEnum, AltaysApplicationStatusEnum, TalentLinkApplicationStatusEnum, BeetweenApplicationStatusEnum } from "@store/applications";

interface ToolRequestModalProps {
  handleClose: () => void;
  itemsName: ApplicationsListEnum;
  adId: string | undefined;
}

const UploadCvModal = (props: ToolRequestModalProps) => {
  const { handleClose, adId, itemsName } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [myFiles, setMyFiles] = useState<File[]>([]);
  const [selectedJobBoard, setSelectedJobBoard] = useState<SelectItem>();
  const [jobBoards, setJobBoards] = useState<SelectItem[]>([]);

  useEffect(() => {
    jobBoardsService.getJobBoards().subscribe({
      next: (j) => setJobBoards(j.map((j) => ({ label: j.name, value: j.id }))),
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  }, [enqueueSnackbar]);

  const handleConfirm = (files: File[]) => {
    if (files?.length) {
      if (!adId) return;
      setLoading(true);
      adDetailsService
        .uploadAdApplications(adId, itemsName, Array.from(files), selectedJobBoard?.value)
        .pipe(finalize(() => setLoading(false)))
        .subscribe({
          next: (applications) => {
            debugger;
            applications.forEach((application) => {
              debugger;
              console.log('application^^^^^^^^^^^^^^^^^^^^', application)
              // Check if ANY service (Altays, TalentLink, or Beetween) has SENT status
              const hasAltaysSent = application.altaysApplicationStatus?.includes(AltaysApplicationStatusEnum.SENT);
              const hasTalentLinkSent = application.talentLinkApplicationStatus?.includes(TalentLinkApplicationStatusEnum.SENT);
              const hasBeetweenSent = application.beetweenApplicationStatus?.includes(BeetweenApplicationStatusEnum.SENT);

              const anyServiceSent = hasAltaysSent || hasTalentLinkSent || hasBeetweenSent;
              const hasAnyStatus = (application.altaysApplicationStatus && application.altaysApplicationStatus.length > 0) ||
                (application.talentLinkApplicationStatus && application.talentLinkApplicationStatus.length > 0) ||
                (application.beetweenApplicationStatus && application.beetweenApplicationStatus.length > 0);

              if (hasAnyStatus) {
                if (anyServiceSent) {
                  enqueueSnackbar(
                    t("applications.sendToBeetweenSuccessWithName", {
                      name: application.candidate?.fullName || application.customName || application.name,
                    }),
                    { variant: "success", autoHideDuration: 5000 }
                  );
                } else {
                  enqueueSnackbar(
                    t("applications.sendToBeetweenErrorWithName", {
                      name: application.candidate?.fullName || application.customName || application.name,
                    }),
                    { variant: "error", autoHideDuration: 5000 }
                  );
                }
              }
            });
            enqueueSnackbar(t("ads.details.applyTab.success.cvs"), { variant: "success" });
            handleClose();
          },
          error: (err) => enqueueSnackbar(err.text, err.options),
        });
    }
  };

  return (
    <ModalComponent
      handleClose={handleClose}
      title={t("applications.uploadApplications")}
      titleLeft
      content={
        <Stack mt="20px" spacing={2}>
          <Stack>
            <Typography fontSize="12px" color={Colors.secondaryText}>
              {t("ads.details.applyTab.selectSource")}
            </Typography>
            <SelectWithSearchComponent
              placeholder={t("ads.details.applyTab.otherSource")}
              handleChange={setSelectedJobBoard}
              items={jobBoards}
              value={selectedJobBoard}
            />
          </Stack>
          <AIODropZone setFiles={setMyFiles} />
        </Stack>
      }
      maxWidth="xs"
      actions={
        <AIOButtonComponent
          title={t("global.confirm")}
          variant="contained"
          ariaLabel="modal"
          onClick={() => handleConfirm(myFiles)}
          disabled={loading}
        />
      }
    />
  );
};

export default UploadCvModal;
